module.exports = __webpack_public_path__ + "e4db9aaf0f00e8360f80457d7b7068b3.svg";